import { useMutation } from '@hooks/reactQuery';

import { getNetworkElementsCheckIpAddress } from '@api/networkElements';

import { handleErrorFromMessage } from '@utils/handleRequestError';

import { IResponseError } from '@interfaces/errors/apiErrors';
import { INetworkElementCheckIpAddressDTO } from '@interfaces/networkElements/dto/networkElements';

import { EErrorCodes } from '@enums/errorCodes';

import { NETWORK_ELEMENTS_CHECK_IP_ADDRESS } from '@constants/queryKeys';

interface IUseMutateNetworkElementsCheckIpAddressReturned {
	handleCheckIpAddress: (dto: INetworkElementCheckIpAddressDTO) => void;
	isLoadingCheckIpAddress: boolean;
}

const useMutateNetworkElementsCheckIpAddress = (): IUseMutateNetworkElementsCheckIpAddressReturned => {
	const {
		mutateAsync,
		isLoading,
	} = useMutation<INetworkElementCheckIpAddressDTO>({
		mutationKey: [NETWORK_ELEMENTS_CHECK_IP_ADDRESS],
		mutationFn: getNetworkElementsCheckIpAddress,
		onError: (err: IResponseError) => {
			if (!err.errors.find((item) => (
				item.code === EErrorCodes.uniqueIpAddress ||
				item.code === EErrorCodes.notValidIpAddress
			))) {
				handleErrorFromMessage(err);
			}
		},
	});

	return {
		handleCheckIpAddress: mutateAsync,
		isLoadingCheckIpAddress: isLoading,
	};
};

export default useMutateNetworkElementsCheckIpAddress;
